export const CUSTOM_ALERT_FREQUENCY = {
  Hour: 0,
  Day: 1,
  Week: 2,
  Month: 3,
};

export const CUSTOM_ALERT_OPERATOR = {
  above: `>`,
  below: `<`,
};

export const CUSTOM_ALERT_TYPE = {
  absolute: `absolute`,
  relativePercent: `relative-percent`,
  relativeValue: `relative-value`,
};

export const DEFAULT_ALERT_NAME = `Untitled alert`;

export const CUSTOM_ALERT_VALIDATION_ERROR = {
  INVALID_EMAIL: `Invalid email address`,
  INVALID_NAME: `Invalid alert name`,
  INVALID_THRESHOLD: `Invalid threshold: must be an integer`,
  INVALID_RATIO_THRESHOLD: `Invalid threshold: must be between 0% and 100%`,
  INVALID_RELATIVE_PERCENTAGE: `Invalid threshold: must be 0% or above`,
  MISSING_VALUE: `Please select a value for each key.`,
};

// TODO a full list of supported result keys/values when we need to support more result types for funnels
export const CUSTOM_ALERT_FUNNELS_DEFAULT_KEYS = [
  {
    name: `$step`,
    displayName: `Step`,
    values: [`$last`],
    displayValues: [`Last`],
    isPercentage: false,
  },
  {
    name: `$analysis`,
    displayName: `Analysis`,
    values: [`$overall_conv_ratio`],
    displayValues: [`Overall conversion rate`],
    isPercentage: true,
  },
];
